import React, { useEffect, useState } from 'react'
import { Form, Toast, Button, Table } from 'react-bootstrap'
import LoadingSpinner from '../../../Components/LoadingSpinner'
import Navbars from '../../../Components/Navbar'
import { initializeApp } from 'firebase/app'
import { getDatabase, ref, set, onValue } from 'firebase/database'
import firebaseConfig from '../../../Utilities/Firebase'

const FirebaseApp = initializeApp(firebaseConfig)
const db = getDatabase(FirebaseApp)
const Vacation = () => {

    const [isLoading, setIsLoading] = useState(true)
    const [show, setShow] = useState(false)
    const [showError, setShowError] = useState(false)
    const [message, setMessage] = useState('')
    const [year, setYear] = useState('1')
    const [vacation, setVacation] = useState([{}])
    const [buttonText, setButtonText] = useState('')
    const yearInWordsshort = ['FE', 'SE', 'TE', 'BE']
    const yearInWords = ['FIRST YEAR', 'SECOND YEAR', 'THIRD YEAR', 'FOURTH YEAR']

    const changeButtonText = (year) => {
        const numberYear = parseInt(year)

        if (vacation[numberYear - 1].vacation === true) {
            setButtonText(`UNSET ${yearInWordsshort[numberYear - 1]} VACATION`)
        } else {
            setButtonText(`SET ${yearInWordsshort[numberYear - 1]} VACATION`)
        }
    }

    const fetchVacation = () => {
        const vacationRef = ref(db, 'vacation/')
        const numberYear = parseInt(year)
        onValue(vacationRef, snapshot => {
            const data = snapshot.val()
            setVacation(data)
            data[numberYear-1].vacation === false ? setButtonText(`SET ${yearInWordsshort[numberYear - 1]} VACATION`) : setButtonText(`UNSET ${yearInWordsshort[numberYear - 1]} VACATION`)
            setIsLoading(false)
        })
    }

    useEffect(() => {
        setIsLoading(true)
        fetchVacation()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const updateVacation = () => {
        setIsLoading(true)
        const vacationCopy = [...vacation]
        const numberYear = parseInt(year)
        vacationCopy[numberYear - 1].vacation = !vacationCopy[numberYear - 1].vacation
        const vacationRef = ref(db, 'vacation/')
        set(vacationRef, {
            ...vacationCopy,
        })
        .then(()=>{
            setShow(true)
            fetchVacation()
        })
        .catch(error => {
            console.log(error)
            setIsLoading(false)
            setMessage('SOME ERROR OCCURED')
            setShowError(true)
            return
        })
    }

    return isLoading ? (
        <LoadingSpinner />
    ) : (
        <div>
            <div style={{ position: 'fixed', bottom: '2%', right: '3%' }}>
                <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide bg="success">
                    <Toast.Body style={{ fontWeight: 'bold', color: 'white' }}>Successfully updated!</Toast.Body>
                </Toast>
            </div>
            <div style={{ position: 'fixed', bottom: '2%', right: '3%' }}>
                <Toast onClose={() => setShowError(false)} show={showError} delay={3000} autohide bg="danger">
                    <Toast.Body style={{ fontWeight: 'bold', color: 'white' }}>{message}</Toast.Body>
                </Toast>
            </div>

            <Navbars type={'1'} />
            <br />
            <br />
            <br />
            <center>
                <Form id="form" style={{ border: '1px black solid', width: '50%' }}>
                    <br />
                    <br />

                    <Form.Group className="mb-3">
                        <Form.Label style={{ marginRight: '5px' }}>YEAR:</Form.Label>
                        <Form.Select
                            value={year}
                            onInput={event => {
                                setYear(event.target.value)
                                changeButtonText(event.target.value)
                            }}
                        >
                            {yearInWords.map((item, index) => {
                                return <option value={index + 1}>{item.split(" ")[0]}</option>
                            })}
                        </Form.Select>
                    </Form.Group>

                    <br />
                    <br />
                    <Button
                        onClick={() => {
                            updateVacation()
                        }}
                    >
                        {buttonText}
                    </Button>
                    <br />
                    <br />
                    <br />
                </Form>
            </center>
            <center style={{ paddingTop: "40px", paddingInline: "200px" }}>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Year</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    {vacation.length > 0 && vacation.map((item, index) => {
                        return (
                            <tbody>
                                <tr>
                                    <td>{index + 1}</td>
                                    <td>{yearInWords[index]}</td>
                                    <td>{item.vacation === true ? 'ON VACATION' : 'NOT ON VACATION'}</td>
                                </tr>
                            </tbody>
                        )
                    })}
                </Table>
            </center>
        </div>
    )

}

export default Vacation